<template>
  <div>
    <div class="mb-8">
      <h1>PaSoRi Settings</h1>
    </div>
    <v-tabs v-model="tab" color="primary">
      <v-tab>Nap Sensor</v-tab>
      <v-tab>VEVO Key Holder</v-tab>
    </v-tabs>

    <v-window v-model="tab">
      <v-window-item>
        <pasori-sensor-container />
      </v-window-item>

      <v-window-item>
        <pasori-vevo-container />
      </v-window-item>
    </v-window>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { classModule } from "@/store/dataModules/classModule";
import LocalDataService from "@/service/LocalDataService";

import PasoriSensorContainer from "@/containers/pasori/PasoriSensorContainer.vue";
import PasoriVevoContainer from "@/containers/pasori/PasoriVevoContainer.vue";

interface DataType {
  tab: number;
}

export default defineComponent({
  components: {
    PasoriSensorContainer,
    PasoriVevoContainer,
  },

  data: (): DataType => {
    return {
      tab: 0,
    };
  },

  async mounted() {
    const nurseryId = LocalDataService.getNurseryId();
    if (nurseryId) {
      await classModule.listClass({
        nurseryId: nurseryId,
      });
    }
  },
});
</script>
